export default __webpack_public_path__ + "static/naftali-logo-f88fa81e691e45d087a155ad99156468.svg";